import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import search from './modules/search'
import loader from './modules/loader'
import searchTableData from './modules/searchTableData'
import merchant from './modules/merchant'
import retailer from './modules/retailer'
import msgSearch from './modules/msgSearch'
import siteFilter from './modules/siteFilter'
import site from './modules/site'
import ui from './modules/ui'
import promotionGroups from './modules/promotionGroups'
import retailerTag from './modules/retailerTag'
import profanityManager from './modules/profanityManager'
import campaigns from './modules/campaigns'
import siteGroup from './modules/siteGroup'
import pretailer from './modules/pretailer'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  getters: {
    traceToken: state => {
      return {
        trace: 'n',
        token: state.user.authToken
      }
    }
  },
  modules: {
    user,
    search,
    loader,
    searchTableData,
    merchant,
    retailer,
    msgSearch,
    siteFilter,
    site,
    ui,
    promotionGroups,
    retailerTag,
    siteGroup,
    pretailer,
    profanityManager,
    campaigns,
  },
})
